/**
 * Copyright 2025 Design Barn Inc.
 */

import React from 'react';

export default function ChevronLeftIcon(): React.ReactElement {
  return (
    <div className="flex items-center justify-center pt-[1px]">
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.02018 4.35348C9.21544 4.54874 9.21544 4.86532 9.02018 5.06058L6.0404 8.04036L9.02018 11.0201C9.21544 11.2154 9.21544 11.532 9.02018 11.7273C8.82492 11.9225 8.50833 11.9225 8.31307 11.7273L4.97974 8.39392C4.78448 8.19866 4.78448 7.88207 4.97974 7.68681L8.31307 4.35348C8.50833 4.15822 8.82492 4.15822 9.02018 4.35348Z"
          fill="#20272C"
        />
      </svg>
    </div>
  );
}
